<template>
	<section
		class="hero h-screen w-full relative overflow-hidden will-change"
		:data-scroll-section="inner == 'false'"
	>
		<!-- hero img / video -->
		<div class="hero__img-wraper">
			<template v-if="blockData.background === 'Video'">
				<video
					autoplay
					muted
					playsinline
					loop
					class="hero__img"
					data-scroll
					data-scroll-speed="-5"
				>
					<source :src="blockData.video.url" />
				</video>
			</template>

			<template v-else>
				<img
					v-if="!isMobile"
					data-scroll
					data-scroll-speed="-5"
					class="hero__img"
					v-show="blockData.image"
					:src="blockData.image.url"
					:alt="blockData.image.alt || 'Lusticabay'"
				/>
				<img
					v-else
					data-scroll
					data-scroll-speed="-5"
					class="hero__img"
					v-show="mobileImage"
					:src="mobileImage && mobileImage.url"
					:alt="mobileImage && (mobileImage.alt || 'Lusticabay')"
				/>
			</template>
		</div>

		<!-- ./hero img / video -->

		<!-- hero content -->
		<div
			class="hero__content flex flex-col relative z-20 w-full h-screen px-3 xl:p-10"
		>
			<div class="uppercase my-auto text-white text-center xl:px-desk">
				<div class="min-h-[36px] overflow-hidden" v-if="blockData.kicker">
					<p
						class="mb-7 leading-5 tracking-desk custom-easing-1"
						xyz="down-100% duration-10 delay-10"
						data-scroll
						data-scroll-class="xyz-in"
						v-html="blockData.kicker"
					></p>
				</div>
				<div class="min-h-[20px] overflow-hidden" v-if="blockData.breadcrumbs">
					<p
						class="breadcrumbs mb-4 xl:mb-9 leading-none xyz-in"
						xyz="down-100% duration-5 delay-1"
					>
						<a class="breadcrumbs-link" :href="homeUrl">{{
							breadcrumbData[language]?.homeTitle
								? breadcrumbData[language]?.homeTitle
								: "Home"
						}}</a
						><span> > </span><span>{{ blockData.title }}</span>
					</p>
				</div>

				<div class="min-h-[36px] overflow-hidden" v-if="blockData.title">
					<h1
						class="text-4xl xl:text-[64px] leading-none text-white font-normal tracking-[1px] custom-easing-1"
						v-html="blockData.title"
						xyz="down-100% duration-10 delay-10"
						data-scroll
						data-scroll-class="xyz-in"
					></h1>
				</div>
			</div>
			<div
				class="socila tracking-desk text-white uppercase text-sm"
				v-show="blockData.social_networks"
			>
				<a v-show="optionsData.instagram" :href="optionsData.instagram">IG</a>
				<a v-show="optionsData.facebook" :href="optionsData.facebook">FB</a>
				<a v-show="optionsData.youtube" :href="optionsData.youtube">YT</a>
				<a v-show="optionsData.twitter" :href="optionsData.twitter">TW</a>
				<a v-show="optionsData.linkedin" :href="optionsData.linkedin">LI</a>
			</div>
		</div>
		<!-- ./hero content -->

		<span class="hero__scrollTo">
			<span
				class="text-xs tracking-little text-white uppercase absolute -top-6 left-1/2 -translate-x-1/2 whitespace-nowrap"
				>{{ __("scroll down", "ccave") }}</span
			>
			<div class="line">
				<div class="background"></div>
				<div class="highlight"></div>
			</div>
		</span>
	</section>
</template>

<script>
import { isMobile } from "mobile-device-detect";
export default {
	name: "Hero",
	data() {
		return {
			scroll: null,
			homeUrl: "",
			language: document.documentElement.lang || "en",
			breadcrumbData: {
				en: {
					homeTitle: "Home",
				},
				"de-DE": {
					homeTitle: "Home",
				},
				"ru-RU": {
					homeTitle: "Главная",
				},
				"sr-ME": {
					homeTitle: "Home",
				},
			},
		};
	},

	mounted() {
		if (document.documentElement.lang.split("-")[0] === "en") {
			this.homeUrl = window.location.origin;
		} else if (document.documentElement.lang.split("-")[0] === "sr") {
			this.homeUrl = `${window.location.origin}/me`;
		} else {
			this.homeUrl = `${window.location.origin}/${
				document.documentElement.lang.split("-")[0]
			}`;
		}
	},
	methods: {},
	computed: {
		mobileImage() {
			return this.blockData.image_mobile || this.blockData.image || null;
		},
	},
};
</script>

<style>
.custom-easing-1 {
	--xyz-ease: cubic-bezier(0, 0.83, 0, 1);
}
</style>
